import { FileType } from '@openeducation/oe-it-shared-types';

interface CreateFileArgs {
  uri: string;
  type: string;
  name: string;
  isWeb: boolean;
}

export async function createFile({ uri, type, name, isWeb }: CreateFileArgs) {
  let file: FileType;

  if (isWeb) {
    const rawBlob = await fetch(uri).then((response) => response.blob());
    file = new File([rawBlob], name);
  } else {
    file = { type, name, uri };
  }

  return file;
}
